import { PageLayout, PageListHeader } from '@/global/components';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { TabItem, Tabs } from '@/lib/Tabs';
import { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import RouteConstants from '../router/RouteConstants';
import { WorkspaceDetails } from './components/WorkspaceDetails';
import { WorkspaceUsers } from './components/WorkspaceUsers';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'settings.breadcrumb',
    path: RouteConstants.settings,
  },
];

const GENERAL_SETTINGS_TABS = 'general';
const USERS_TABS = 'users';
const SETTINGS_TABS: TabItem[] = [
  {
    id: GENERAL_SETTINGS_TABS,
    title: `settings.tabs.${GENERAL_SETTINGS_TABS}`,
    element: <WorkspaceDetails />,
  },
  {
    id: USERS_TABS,
    title: `settings.tabs.${USERS_TABS}`,
    element: <WorkspaceUsers />,
  },
];

export const Settings: FC = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const currentTab = searchParams.get('tab');

  const handleSelectTab = (tab: TabItem) => {
    history.push(`${RouteConstants.settings}?tab=${tab.id}`);
  };

  return (
    <PageLayout>
      <PageListHeader breadcrumbs={breadcrumbs} title='settings.title_v2' subtitle='settings.subtitle_v2'></PageListHeader>
      <Tabs items={SETTINGS_TABS} currentTab={`settings.tabs.${currentTab || GENERAL_SETTINGS_TABS}`} onSelectTab={handleSelectTab} />
    </PageLayout>
  );
};
